import React, { Component } from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const ProductWrapper = styled.div`
  max-width: 786px;
  width: 96%;
  margin: 0 auto;
  .slick-next:before,
  .slick-prev:before {
    color: #124b5f;
  }

  .slick-track {
    display: flex;
    & > div {
      margin: 0 10px 10px 0 !important;
      padding-top: 14px;
    }
  }
  .slick-active.slick-center.slick-current {
    & > div div:focus {
      outline: none !important;
    }
  }
`
const ListWrapper = styled.div`
  max-width: 786px;
  margin: 0 auto;
  width: 100%;
  margin: 0;
  & > div button {
    display: none !important;
  }
  .slick-list {
    padding: 10px 16px 0 16px !important;
  }
  .slick-track {
    display: flex;
    & > div {
      width: 135px !important;
      margin: 0 10px 10px 0 !important;
    }
  }
  .slick-slide.slick-active.slick-current {
    & > div > div {
      border: 1px solid #078489;
      .shape {
        background: #078489 !important;
        & > p {
          color: #fff !important;
        }
      }
    }
  }
  .slick-active.slick-center.slick-current {
    /* & > div div:focus {
      outline: none !important;
    } */
    & > div > div {
    }
    & > div > div > .shape {
      background: #078489 !important;
    }
    & > div > div {
      border: 1px solid #078489 !important;
      & > div:first-child {
        // background: #078489;
        & > p {
          color: #fff;
        }
      }
    }
  }
`
const SliderWrapper = styled.div`
  max-width: 786px;
  margin: 0 auto;
  width: 100%;
  // margin: 20px 0 0px;
  @media (max-width: 768px) {
    & > div button {
      display: none !important;
    }
  }
  @media (min-width: 769px) {
    & > div button {
      display: block !important;
    }
    .slick-next:before,
    .slick-prev:before {
      color: #078489;
    }
  }
  .slick-track {
    & > div {
      width: 145px !important;
      margin: 0 10px 0 0 !important;
    }
    @media (max-width: 336px) {
      & > div {
        width: 125px !important;
      }
    }
  }
  .slick-list {
    padding: 0px !important;
    padding-bottom: 10px !important;
  }

  .slick-active.slick-center.slick-current {
    & > div div:focus {
      outline: none !important;
    }

    & > div > div {
      background: #078489 !important;
      & svg path {
        fill: #fff;
      }
      & svg circle {
        fill: #fff;
      }
      & p {
        color: #fff;
      }
    }
  }
`
class Slick extends Component {
  state = {}
  render() {
    const { children, type, ...props } = this.props
    const productSettings = {
      className: 'slider center',
      dots: false,
      infinite: false,
      speed: 100,
      centerPadding: '4px 60px',
      responsive: [
        {
          breakpoint: 2048,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    }
    const listSettings = {
      className: 'slider',
      focusOnSelect: true,
      infinite: false,
      centerPadding: '4px 60px',
      slidesToShow: 4,
      speed: 200,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 2048,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }
    const settings = {
      className: 'slider center',
      infinite: false,
      centerPadding: '4px 60px',
      slidesToShow: 4,
      swipeToSlide: true,
      centerMode: true,
      focusOnSelect: true,
      speed: 50,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 2048,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }
    return (
      <React.Fragment>
        {type === 'product' ? (
          <ProductWrapper>
            <Slider {...productSettings} {...props}>
              {children}
            </Slider>
          </ProductWrapper>
        ) : type === 'list' ? (
          <ListWrapper>
            <Slider {...listSettings} {...props}>
              {children}
            </Slider>
          </ListWrapper>
        ) : (
          <SliderWrapper>
            <Slider {...settings} {...props}>
              {children}
            </Slider>
          </SliderWrapper>
        )}
      </React.Fragment>
    )
  }
}

export default Slick



// WEBPACK FOOTER //
// ./src/components/Slick.js